<template>
  <section>
    <modal :title="title" :show="showModal" @close="closeModal()">
      <div class="content" slot="content">
        <div class="flex end actions">
            <div class="button secondary" @click="openModalNew()">
              Adicionar nova tag
            </div>
        </div>
        <ul class="margin-top-s">
          <li v-if="false">
            <small>
              Adicione sua primeira mensagem para começar a rodar sua campanha.
            </small>
          </li>
          <li v-for="(m, k) in tags" :key="k">
            <div class="flex middle">
              <div class="flex-2">
                {{ m.name }}
              </div>
              <div class="flex-1 flex end">
                <div class="button secondary" @click="openModalEdit(m)">
                  Editar
                </div>
                <div class="button secondary" @click="openModalDelete(m.id)">
                  Deletar
                </div>
              </div>
            </div>
          </li>
        </ul>

      </div>
      <div class="action" slot="action">
        <div class="flex center">
          <a @click="closeModal()" class="button secondary medium">
            Fechar
          </a>
        </div>
      </div>
    </modal>
    <!-- new list -->
    <new-tag
      :show="showEditModal"
      :tag="newTag"
      @close="
        showEditModal = false;
        newTag = null;
      "
      @accept="newOrEditTag($event)"
    ></new-tag>
    <!-- modal confirm delete -->
    <modal-confirm
      :show="showDeleteModal"
      description="Você tem certeza que deseja deletar essa tag?"
      @cancel="
        showDeleteModal = false;
        selectModalDelete = null;
      "
      @accept="removeTag(selectModalDelete)"
    ></modal-confirm>
  </section>
</template>

<script>
import { getTags, createTag, updateTag, removeTag } from "@/services/tag";

import Modal from "@/components/modal/Modal";
import ModalConfirm from "@/components/modal/ModalConfirm";
import NewTag from "./NewTag";

const auxnewTag = {
  name: ''
}

export default {
  name: "modal-tags",
  props: {
    titleName: {
      required: false,
      default: "Listas",
    },
    show: {
      required: true,
      default: false,
    },
    unusual: {
      required: false,
      default: "false",
    },
    tag: {
      required: true,
      default: Object,
    },
  },
  components: {
    Modal,
    ModalConfirm,
    NewTag,
  },
  data() {
    return {
      showDeleteModal: false,
      selectModalDelete: null,
      newTag: null,
      showEditModal: false,
      showModal: false,
      seenGuide: {},
      title: "Tags",
      tags: [],
    };
  },
  watch: {
    show(value) {
      this.showModal = value;
    },
  },
  mounted() {
    this.getTags();
  },
  computed: {
    isEdit() {
      return this.tag && this.tag.id;
    },
  },
  methods: {
    newOrEditTag(auxTag) {
      this.showEditModal = false
      this.newTag = null

      if (auxTag.id) {
        return this.updateTag(auxTag)
      } 

      return this.createTag(auxTag)
    },
    openModalEdit(listAux) {
      this.showEditModal = true
      this.newTag = listAux
    },
    openModalNew() {
      this.showEditModal = true
      this.newTag = Object.assign({}, auxnewTag)
    },
    openModalDelete(tagId) {
      this.showDeleteModal = true
      this.selectModalDelete = tagId
    },
    getTags() {
      getTags()
        .then((result) => {
          this.tags = result;
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "falha ao buscar tags",
          });
        });
    },
    createTag(tag) {
      createTag(tag)
        .then((result) => {
          this.tags.push(result);
          this.$toast.success({
            title: "Sucesso",
            message: "Tag criada com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falha ao criar tags",
          });
        });
    },
    updateTag(tag) {
      updateTag(tag.id, tag)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Tag editada com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falha ao editar tag",
          });
        });
    },
    removeTag(tagId) {
      removeTag(tagId)
        .then(() => {

          this.tags = this.tags.filter(l => l.id != tagId)
          this.$toast.success({
            title: "Sucesso",
            message: "Tag removida com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falha ao remover tag",
          });
        })
        .finally(() => {
          this.showDeleteModal = false
          this.selectModalDelete = null
        })
    },
    acceptModal() {
      this.showModal = false;
      this.$emit("accept", this.tag);
    },
    closeModal() {
      this.showModal = false;
      this.$emit("close", false);
    },
  },
};
</script>

<style lang="scss" scoped>


.action {
  margin-top: 30px;
  .button {
    margin-left: 10px !important;
  }
}

textarea {
  border-radius: 5px;
  border: 1px solid #3333;
  padding: 15px;
  max-width: 500px;
  min-width: 500px;
  min-height: 150px;
  max-height: 150px;
}

ul {
  list-style: none;
  max-height: 350px;
  overflow-y: scroll;
  li {
    padding: 4px 8px;
    border-bottom: 1px solid #ccc;
    .tag {
      background: #c2c2c2;
      padding: 4px 6px;
      border-radius: 5px;
      font-size: 11px;
      font-weight: 800;
      margin-left: 8px;
    }
    .button {
      margin-left: 4px;
      padding: 4px 6px;
    }
  }
}
</style>
